import { ClientEvents } from 'common/events/ClientEvents';
import { EXP_VAR_TREATMENT, ExperimentNames } from 'common/experiments/ExperimentDefinitions';
import React, { useCallback } from 'react';
import CoinGuy from 'src/assets/svg/coin-guy.svg';
import { useVariant } from 'src/experimentation/useVariant';
import { useTracker } from 'src/shared/hooks/useTracker';
import { useIsDishFirst } from '../../../../../../dish-first/useIsDishFirst';
import { useBulkDiscountModalContext } from '../BulkDiscountModal';
import { MiniBanner } from './components/MiniBanner';

export const BulkDiscountBanner: React.FC<{ className?: string }> = ({ className }) => {
  const tracker = useTracker();

  const { variant } = useVariant(ExperimentNames.BULK_DISCOUNT);
  const { show } = useBulkDiscountModalContext();
  const { isDishFirst } = useIsDishFirst();

  const onClick = useCallback(() => {
    show();
    tracker.track(ClientEvents.BULK_DISCOUNT_EXPLORE_CLICK, {});
  }, [tracker, show]);

  if (variant?.name !== EXP_VAR_TREATMENT) {
    return null;
  }

  // We dont do bulk discount in shef lite markets as we cant offer free delivery (for now)
  if (!isDishFirst) {
    return null;
  }

  return (
    <MiniBanner
      className={className}
      bgColorClassName='bg-elderberry-50'
      supportingText='Buy more, save more'
      mainText='Get up to 10% OFF!'
      ctaText='Learn more'
      ctaClick={onClick}
      graphic={<img src={CoinGuy} alt='' className='mb-4 mr-4 size-20 object-contain md:size-24' />}
    />
  );
};
